import { Button, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Spacer } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';

interface FooterProps {
  onUpdateOrder: () => void;
  sendButtonIsDisabled: boolean;
}

export const Footer: React.FC<FooterProps> = ({ onUpdateOrder, sendButtonIsDisabled }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const goToHistoryOrders = () => {
    navigate('OrdersHistory');
  };

  return (
    <Stack
      py={{ base: 0, sm: Spacing['inset.sm'] }}
      direction={{ base: 'column', sm: 'row' }}
      alignItems="center"
      justifyContent="space-between">
      {!isMobile && <Spacer />}
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        space={Spacing['inline.xxxs']}
        {...(isMobile && { width: 'full' })}>
        {!isMobile && (
          <Button
            _text={{ fontWeight: Typography['fontweight.semibold'] }}
            {...(isMobile && { w: 'full' })}
            onPress={goToHistoryOrders}
            variant="secondary">
            Cancelar edição
          </Button>
        )}
        <Button
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          isDisabled={sendButtonIsDisabled}
          {...(isMobile && { w: 'full' })}
          variant={'callToAction'}
          onPress={onUpdateOrder}>
          Enviar
        </Button>
      </Stack>
    </Stack>
  );
};
